import { oneOf, oneOfType, string } from 'prop-types';
var cursorEnum = ['auto', 'default', 'none', 'context-menu', 'help', 'pointer', 'progress', 'wait', 'cell', 'crosshair', 'text', 'vertical-text', 'alias', 'copy', 'move', 'no-drop', 'not-allowed', 'e-resize', 'n-resize', 'ne-resize', 'nw-resize', 's-resize', 'se-resize', 'sw-resize', 'w-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'col-resize', 'row-resize', 'all-scroll', 'zoom-in', 'zoom-out', 'grab', 'grabbing '];
var touchActionEnum = ['auto', 'inherit', 'manipulation', 'none', 'pan-down', 'pan-left', 'pan-right', 'pan-up', 'pan-x', 'pan-y', 'pinch-zoom'];
var userSelectEnum = ['auto', 'text', 'none', 'contain', 'all'];
var InteractionPropTypes = {
  cursor: oneOfType([string, oneOf(cursorEnum)]),
  touchAction: oneOf(touchActionEnum),
  userSelect: oneOf(userSelectEnum),
  willChange: string
};
export default InteractionPropTypes;